<template>
  <div class="code-widget">
    <h3><slot></slot></h3>
    <div>
      <div>
        <param-input-number v-model="limitObj" optional>
          limit
          <template #description>
            The maximum number of results to return. Use 0 to return all results. Defaults to 20.
          </template>
        </param-input-number>
      </div>
      <div>
        <param-input-number v-model="offsetObj" optional>
          offset
          <template #description>
            Skips ahead this many entries in the returned results. Useful for pagination. Defaults
            to 0.
          </template>
        </param-input-number>
      </div>
    </div>
    <code-example
      :params="[limitObj, offsetObj]"
      :method="method"
      :request-url="requestUrl"
      :language="language"
      @language-change="$emit('language-change', $event)"
      :url-params="urlParams"
      :username="username"
      :password="password"
      :user-url-base="userUrlBase"
      :proxy-url-base="proxyUrlBase"
      >GET list</code-example
    >
  </div>
</template>

<script>
import { escapeMixin } from "../mixins/escapeMixin.js";
import { languageMixin } from "../mixins/languageMixin.js";

import ParamInputNumber from "./ParamInputNumber.vue";
import CodeExample from "./CodeExample.vue";

export default {
  name: "ListMethodWidget",
  components: {
    "param-input-number": ParamInputNumber,
    "code-example": CodeExample,
  },
  mixins: [escapeMixin, languageMixin],
  data: function () {
    return {
      limitObj: { value: "", varName: "limit" },
      offsetObj: { value: "", varName: "offset" },
      requestUrl: "/rest/list/",
      method: "get",
    };
  },
  computed: {
    urlParams: function () {
      return [this.limitObj, this.offsetObj];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}*/
</style>
